import React from "react";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";

import {
  Input,
  Button,
  Space,
  Row,
  Col,
  Checkbox,
  Dropdown,
  Modal,
  Image,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import MapForVehiclePosition from "./MapForVehiclePosition";

import StationaryReportStore from "../store/StationaryReportStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import duration from "dayjs/plugin/duration";

import dayjs from "dayjs";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";

dayjs.extend(duration);

class StationaryReportList extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.stationaryReportStore = new StationaryReportStore();

    this.state = {
      loading: false,
      loadData: 0,
      pageSize: 50,
      offset: 0,
      limit: 50,
      pageNo: 1,
      companyId: "",
      modalVisible: false,
      filter: "",
      column: "",
      hours: "",
      showMap: false,

      vehicleObj: false,
      selectedColumns: [
        {
          // title: "Vehicle No",
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
          dataIndex: "vehicleNo",
          width: 100,
          ellipsis: { showTitle: true },
          key: "vehicleNo",
        },

        {
          // title: "Driver",
          title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
          dataIndex: "name",
          width: 100,
          ellipsis: { showTitle: true },
          key: "name",
        },

        {
          // title: "Location",
          title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_LOCATION_"),
          dataIndex: "location",
          width: 190,
          ellipsis: { showTitle: true },
          key: "location",
          render: (location) => (
            <Tooltip placement="topLeft" title={location}>
              {location}
            </Tooltip>
          ),
        },
        {
          // title: "Region",
          title: context.translate("_REGION_"),
          dataIndex: "region",
          width: 100,
          ellipsis: { showTitle: true },
          key: "region",
        },
        {
          // title: "Stationary From",
          title: context.translate("_STATIONARY_FROM_"),
          dataIndex: "stopFrom",
          width: 80,
          ellipsis: { showTitle: true },
          key: "stopFrom",
        },
        {
          // title: "Stop Since",
          title: context.translate("_STOP_SINCE_"),
          dataIndex: "stopSince",
          width: 80,
          ellipsis: { showTitle: true },
          key: "stopSince",
          render: (c) => {
            console.log(c);

            var g, f, b, e;
            e = c;
            b = Math.floor(e / 60);
            e = e % 60;
            f = Math.floor(b / 60);
            b = b % 60;
            g = Math.floor(f / 24);
            f = f % 24;
            var a = (g < 10 ? "0" + g : g) + " days,";
            a += f < 10 ? "0" + f : f;
            a += ":" + (b < 10 ? "0" + b : b);
            a += ":" + (e < 10 ? "0" + e : e);
            return a;

            // const formattedTime = this.formatSecondsToTime(value);

            // return <div>{formattedTime}</div>;
          },
        },

        {
          // title: "View On Map",
          title: context.translate("_FLEET_SERVICE_POILIST_VIEWMAP_"),
          dataIndex: "viewonmap",
          width: 50,
          ellipsis: { showTitle: true },
          key: "viewonmap",
          render: (value, obj) => {
            return (
              <>
                <Image
                  src={require("../assets/images/mapIcon/gps_icon.png")}
                  width={25}
                  height={25}
                  onClick={async () => {
                    await this.setState({
                      vehicleObj: { ...obj, icon: "map-car-icon-green.png" },
                      // heading: "Track Data Map",
                      heading: this.context.translate("_TRACK_DATA_REPORT_"),
                    });
                    await this.setState({ loadData: 1 });
                  }}
                />

                {/* <Link
                  // onClick={(e) =>
                  //   this.setState({ showMap: true, modalInfoObj: obj })
                  // }
                  onClick={async (e) => {
                    // await this.setState({ showMap: true, modalInfoObj: obj });
                    await this.setState({ vehicleObj:{...obj,icon:"logo_icon.png"},heading:"Track Data Map" });
                    await this.setState({loadData:1})
                  }}
                >
                  {" "}
                  <img
                    src={require("../assets/images/mapIcon/gps_icon.png")}
                    width={25}
                    height={25}
                  />
                </Link> */}
              </>
            );
          },
        },
      ],
    };
    this.menuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },

        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        let result = [];

        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            companyId: this.state.companyId,
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            hours: this.state.hours,
            colList: result.toString(),
          };

          if (val.key == "excel") {
            this.stationaryReportStore.exportExcel(getData);
          }

          if (val.key == "pdf") {
            this.stationaryReportStore.exportpdf(getData);
          }
        }
      },
    };

    this.newColumns = [...this.state.selectedColumns];
  }

  async componentDidMount() {
    this.setState({ pageSize: 50 });
    // await this.stationaryReportStore.loadData({ offset: 0, limit: 50 });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;
      console.log(companyId);
      await this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }

    await this.setState({ column: this.state.selectedColumns });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.vehicleObj !== prevState.vehicleObj) {
      console.log("ilocasd");
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pagesize: 50,
    });
    // await this.vehicleStore.getVehiclesCompanyId({ companyId: comp.value });
    await this.handleSearch();

    // console.log("data", data);
  }

  async handleSearch() {
    // await this.stationaryReportStore.loadData({
    //   offset: (this.state.pageNo - 1) * this.state.pageSize,
    //   limit: this.state.pageSize,
    //   // companyId: this.state.companyId,
    //   pageNo: this.state.pageNo,
    //   // hours: this.state.hours,
    // });
    // await this.setState({ loadData: 1 });
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      pageNo: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.showData();
  }
  showData = async () => {
    console.log("company", this.state.companyId);
    await this.stationaryReportStore.loadData({
      offset: (this.state.pageNo - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      hours: this.state.hours,
      pageNo: this.state.pageNo,
    });
    await this.setState({ loadData: 1 });
  };

  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };
  refreshList = async () => {
    await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
    await this.showData();
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  allowClear={true}
                  className="searchInput"
                  onChange={this.handleChange}
                  style={{ width: 200 }}
                />

                <Input
                  style={{ width: 100, borderRadius: "25px" }}
                  // placeholder="Hours"
                  placeholder={this.context.translate("_hour_")}
                  value={this.state.hours}
                  className="searchInput"
                  onChange={(e) => this.setState({ hours: e.target.value })}
                />

                <Button
                  type="primary"
                  onClick={async () => {
                    await this.setState({ pageSize: 50, pageNo: 1 });
                    this.showData();
                  }}
                >
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col span={4}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.stationaryReportStore?.stationaryReport?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.menuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {console.log(this.newColumns, "Df")}
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            key={this.state.selectedColumns.length}
            currentPage={this.state.pageNo}
            pageSize={this.state.pageSize}
            total={this.stationaryReportStore?.total}
            columns={this.state.selectedColumns}
            dataSource={this.stationaryReportStore?.stationaryReport}
            loading={this.stationaryReportStore?.loading}
            onChange={this.handleTableChange}
            // pagination={{
            //   pageSize: this.state.pageSize,
            //   total: this.stationaryReportStore.total || 0,
            // }}
            // scroll={{
            //   // y: this.state.clientHeight-240,
            //   x: 100,
            // }}
          />

          {/* <Modal
            title="Trip Report Map"
            open={this.state.showMap}
            centered
            // bodyStyle={{ height: 1000 }}
            width={500}
            onOk={() => this.setState({ showMap: false })}
            onCancel={() => this.setState({ showMap: false })}
            footer={false}
          >
            <MapContainer
              ref={this.mapRef}
              zoom={14}
              center={[
                this.state.modalInfoObj.latitude,
                this.state.modalInfoObj.longitude,
              ]}
              style={{ height: "300px", width: "450px" }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                // attribution="Map data © OpenStreetMap contributors"
              />

              <Marker
                icon={dotIcon}
                position={[
                  this.state.modalInfoObj.latitude,
                  this.state.modalInfoObj.longitude,
                ]}
              >
               
                <Popup>{this.state.modalInfoObj.vehicleNo}</Popup>
              </Marker>
            </MapContainer>
          </Modal> */}

          {this.state.vehicleObj && (
            <MapForVehiclePosition
              vehicleObj={this.state.vehicleObj}
              heading={this.state.heading}
              closeMapModal={(resp) => {
                this.setState({ vehicleObj: resp });
              }}
            />
          )}
        </div>
      </>
    );
  }
}
StationaryReportList.contextType = StoreContext;
export default observer(withRouter(StationaryReportList));
